import { cn } from '@/lib/utils';

/** One button of a segmented control (queue tabs, toggles). */
export const pcmpSegmentClass = (active: boolean) =>
  cn(
    'h-8 shrink-0 gap-1.5 px-3',
    active
      ? 'bg-card text-foreground shadow-sm hover:bg-card'
      : 'text-muted-foreground hover:text-foreground',
  );
